import axios from "@/lib/request";

const appHeaders = {
  AppKey: "BpLnfgDs"
};

export const getOfflineBusinessOrderList = params => {
  return axios.request({
    url: "/v1/admin/hynb/offline/order/list",
    method: "get",
    params,
    headers: appHeaders
  });
};

export const getOfflineBusinessOrderInfo = params => {
  return axios.request({
    url: "/v1/admin/hynb/offline/order/info",
    method: "get",
    params,
    headers: appHeaders
  });
};

export const saveOfflineBusinessOrder = data => {
  return axios.request({
    url: "/v1/admin/hynb/offline/order/save",
    method: "post",
    data,
    headers: appHeaders
  });
};

export const deleteOfflineBusinessOrder = data => {
  return axios.request({
    url: "/v1/admin/hynb/offline/order/delete",
    method: "post",
    data,
    headers: appHeaders
  });
};

export const updateOfflineBusinessOrder = data => {
  return axios.request({
    url: "/v1/admin/hynb/offline/order/update",
    method: "post",
    data,
    headers: appHeaders
  });
};

export const getOfflineBusinessChannelList = params => {
  return axios.request({
    url: "/v1/admin/cmn/channel/list",
    method: "get",
    params,
    headers: appHeaders
  });
};

export const getOfflineBusinessProvinceList = params => {
  return axios.request({
    url: "/v1/admin/cmn/province/list",
    method: "get",
    params,
    headers: appHeaders
  });
};

export const getOfflineBusinessCityList = params => {
  return axios.request({
    url: "/v1/admin/cmn/city/list",
    method: "get",
    params,
    headers: appHeaders
  });
};

export const getOfflineBusinessInsuranceCompanyList = params => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/list",
    method: "get",
    params,
    headers: appHeaders
  });
};

export const getCompanyInvoiceInfo = params => {
  return axios.request({
    url: "/v1/admin/cmn/get/company/address",
    method: "get",
    params,
    headers: appHeaders
  });
};

export const uploadOfflineBusinessFile = data => {
  return axios.request({
    url: "/res/file/upload",
    method: "post",
    data,
    headers: {
      ...appHeaders,
      "Content-Type": "multipart/form-data"
    }
  });
};
